import styled from 'styled-components';

export const PatternCodeContainer = styled.div`
  & .pt-item-edit-row {
    border: 1px solid transparent;
    border-radius: 10px;
    padding: 2px;
  }

  & .pt-item-edit-row:hover {
    border-color: #69B1FF;
  }

  & .pt-item-edit-row .ant-select {
    width: 108px;
  }
`;
